// colors.ts
export const categoryColors: { [key: string]: string } = {
    Groceries: '#4A7C59',        // primary green
    Utilities: '#7DA17A',        // secondary green
    Rent: '#5A3E36',             // accent brown
    Entertainment: '#A88F77',    // light brown
    Transportation: '#BFB1A8',   // lighter neutral
    Healthcare: '#F4F1ED',       // background color (can tweak with border)
    Other: '#9C8C82',             // muted brown
  };
  